import { Container, Splash, useAlignments, useScreen } from 'metrix-common3';
import styled from 'styled-components';

const HeroContainer = styled(Container)`
    min-height: ${({ isMobile }) => (isMobile ? '185' : '300')}px;
    width: ${({ isMobile }) => (isMobile ? '375px' : '100%')};
    max-width: 960px;
    margin: 0 auto;
`;

const Hero = (props) => {
    const alignments = useAlignments();
    const screen = useScreen();

    const getHero = () => {
        if (screen?.isMobile) {
            return (
                <svg width='200' height='250' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                    <rect
                        x='200'
                        y='200'
                        rx='200'
                        ry='200'
                        width='30'
                        height='30'
                        stroke='#CCCCCC'
                        fill='#CCCCCC'
                        stroke-width='5'
                    />
                </svg>
            );
        }
        return (
            <svg width='200' height='250' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                <rect
                    x='200'
                    y='200'
                    rx='200'
                    ry='200'
                    width='30'
                    height='30'
                    stroke='#CCCCCC'
                    fill='#CCCCCC'
                    stroke-width='5'
                />
            </svg>
        );
    };

    return (
        <Splash background={getHero()}>
            <HeroContainer
                fullSize
                isMobile={screen?.isMobile}
                verticalAlignment={alignments.center}
                horizontalAlignment={alignments.center}
            >
                {props.children}
            </HeroContainer>
        </Splash>
    );
};

export default Hero;
